import { render, staticRenderFns } from "./LikesView.vue?vue&type=template&id=15ee5f1d&scoped=true&"
import script from "./LikesView.vue?vue&type=script&lang=js&"
export * from "./LikesView.vue?vue&type=script&lang=js&"
import style0 from "./LikesView.vue?vue&type=style&index=0&id=15ee5f1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ee5f1d",
  null
  
)

export default component.exports